import React, { useContext, useEffect } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import CouponEvent from './CouponEvent';
import PotentialWinBox from './PotentialWinBox';
import SystemTuples from './SystemTuples';
import { getConfiguration } from '../../data/utils/configuration';
import { ShopContext } from '../../data/shop/ShopConf';

function SystemBets(props) {
    const betslipContext = useContext(BetslipContext);
	
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const container = "systembets";
    const reactKeyPWB = 'key-potential-win-box-coupon-' + couponKey + '-container-' + container;
    const reactKeyTuples = 'key-tuples-container' + couponKey + '-container-' + container;
    let selections = coupon.selections;
    
    const conf = getConfiguration();
    const shopContext = React.useContext(ShopContext);
    const fastbetAliasEnabled = shopContext.enabled && conf.fbt === 'XR';
    
    let classContainer = "widget-schedina-giocate" + (betslipContext.isKeypadShown()? ' keypad-shown' : '');
    if(fastbetAliasEnabled){
    	classContainer += ' adj-margin-top'; 
    }
    

    return (
        <div className="tab-pane active" id="widget-schedina-1_sistemi" role="tabpanel">
            <div id="systembets-widget-selections" className={classContainer}>
                {selections.map(function(selection) {
				    let reactKey = "key-bet-event-coupon-" + couponKey + "-container-" + container + "-pal-" + selection.pal + "-avv-" + selection.avv;
					return (
                        <React.Fragment key={reactKey}>
                            <CouponEvent selection={selection} couponKey={couponKey} container={container} />
                        </React.Fragment>
                    )
				})}
                <SystemTuples container={container} couponKey={couponKey} key={reactKeyTuples} />
                <div className="hidden-element"></div>
            </div>
            <div className="carrello-fixed">
                <PotentialWinBox container={container} couponKey={couponKey} key={reactKeyPWB} />
            </div>
        </div>
    );
}

export default SystemBets;